import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import keys from 'lodash.keys';
import values from 'lodash.values';
import isOrderAssignedToUser from '@app/util/is-order-assigned-to-user';
import { QUEUE_FINALIZED } from '@chama/utils/constants/status';
import { fetchOrderEventHistory } from '@app/actions/order-event-history';
import { getNearbyDealers } from '@app/actions/dealers';
import {
  assignTicketToCurrentUser,
  unAssignTicketToCurrentUser,
  startDelivery,
  declineOrder,
  deliverOrder,
  cancelDelivery,
  setCurrentOrder,
  cancelOrder,
  dismissOrder,
  fetchOrderDetails,
} from '@app/actions/orders';
import OrderDetailsLayout from '../components/OrderDetailsLayout';

const propTypes = {
  setCurrentOrder: PropTypes.func.isRequired,
  fetchOrderEventHistory: PropTypes.func.isRequired,
  fetchOrderDetails: PropTypes.func.isRequired,
  dealer: PropTypes.object,
  order: PropTypes.object,
};

const defaultProps = {
  order: undefined,
  dealer: {},
};

const unassignTicketToCurrentUserIfRequired = props => {
  const {
    order: {
      currentTicket: { id },
    },
  } = props;

  props.unAssignTicketToCurrentUser(id);
};

class OrderDetails extends Component {
  state = {
    isFetchingOrderDetails: true,
    error: null,
    orderDetails: null,
  };

  componentDidMount() {
    const {
      order: { id, dealerId },
    } = this.props;

    this.fetchOrderDetails(dealerId, id);
  }

  componentWillMount() {
    const { router, routes } = this.props;

    const routerLeaveHook = router.setRouteLeaveHook(routes[1], () => {
      const {
        isAssignedToCurrentUser,
        order: {
          currentTicket: { queue },
        },
      } = this.props;

      if (isAssignedToCurrentUser && queue !== QUEUE_FINALIZED) {
        unassignTicketToCurrentUserIfRequired(this.props);
        routerLeaveHook();
      }

      this.closeDetails();

      return true;
    });
  }

  componentWillReceiveProps(nextProps) {
    const nextOrder = nextProps.order;
    const prevOrder = this.props.order;

    if (prevOrder && nextOrder) {
      const orderChanged = prevOrder.id !== nextOrder.id;
      const { isAssignedToCurrentUser } = this.props;

      if (orderChanged) {
        this.fetchOrderDetails(nextOrder.dealerId, nextOrder.id);
      }

      if (orderChanged && isAssignedToCurrentUser) {
        // User changed order by clicking another one
        unassignTicketToCurrentUserIfRequired(this.props);
      }
    }
  }

  fetchOrderDetails(dealerId, orderId) {
    const { fetchOrderDetails } = this.props;

    this.setState({ isFetchingOrderDetails: true }, async () => {
      try {
        const orderDetails = await fetchOrderDetails(dealerId, orderId);
        this.setState({
          isFetchingOrderDetails: false,
          orderDetails,
        });
      } catch (error) {
        console.error(error);
        this.setState({
          error,
          isFetchingOrderDetails: false,
        });
      }
    });
  }

  onCloseDetailsBtnClick = () => {
    const {
      isAssignedToCurrentUser,
      order: {
        currentTicket: { queue },
      },
    } = this.props;

    if (isAssignedToCurrentUser && queue !== QUEUE_FINALIZED) {
      unassignTicketToCurrentUserIfRequired(this.props);
    }

    this.closeDetails();
  };

  closeDetails = () => this.props.setCurrentOrder(null);

  fetchEventHistory = () => {
    const {
      dealer: { id },
      order,
    } = this.props;

    return this.props.fetchOrderEventHistory(id, order.id);
  };

  render() {
    const { isFetchingOrderDetails, orderDetails, error } = this.state;

    return (
      <React.Fragment>
        {error && <b>{JSON.stringify(error)}</b>}
        <OrderDetailsLayout
          {...this.props}
          orderDetails={orderDetails}
          isFetchingOrderDetails={isFetchingOrderDetails}
          onCloseDetailsBtnClick={this.onCloseDetailsBtnClick}
          closeDetails={this.closeDetails}
          fetchEventHistory={this.fetchEventHistory}
        />
      </React.Fragment>
    );
  }
}

OrderDetails.propTypes = propTypes;
OrderDetails.defaultProps = defaultProps;

const mapStateToProps = state => {
  const {
    dealer,
    orders,
    auth: { chamaID },
    orderEventHistory,
  } = state;
  const { currentOrderId, beingProcessedOrderIds } = orders;
  const order = orders.dict[currentOrderId];
  const isOrderBeingProcessed = beingProcessedOrderIds.indexOf(order.id) !== -1;

  const currentUser = chamaID;

  if (!order) {
    // forcing a falsey value
    return {
      order: null,
    };
  }

  const dealerOrder = dealer.all[order.dealerId];
  const reduceNumberOfDealers = (accum, dealerId) => {
    const hasId = !!dealer.all[dealerId].id;

    if (hasId) {
      return accum + 1;
    }

    return accum;
  };
  const isLoadingCommand = orders.isExecutingCommand;
  const isLoadingAssignment = orders.isExecutingAssignment;
  const displayDealerName = keys(dealer.all).reduce(reduceNumberOfDealers, 0) > 1;
  const nearbyDealersList = values(dealer.nearby.dict).map(nearbyDealer => {
    const dealerInDealersAdmin = dealer.all[nearbyDealer.id];

    if (dealerInDealersAdmin) {
      return {
        ...nearbyDealer,
        isActive: dealerInDealersAdmin.isActive,
      };
    }

    return nearbyDealer;
  });

  return {
    order,
    displayDealerName,
    isLoadingCommand,
    isLoadingAssignment,
    dealer: dealerOrder,
    nearbyDealersList,
    isOrderBeingProcessed,
    currentUser,
    isAssignedToCurrentUser: isOrderAssignedToUser(currentUser, order),
    eventHistory: orderEventHistory.orders[order.id],
    isFetchingEventHistory: orderEventHistory.isFetching,
  };
};

const mapDispatchToProps = {
  unAssignTicketToCurrentUser,
  assignTicketToCurrentUser,
  startDelivery,
  declineOrder,
  deliverOrder,
  cancelOrder,
  dismissOrder,
  cancelDelivery,
  getNearbyDealers,
  setCurrentOrder,
  fetchOrderEventHistory,
  fetchOrderDetails,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(OrderDetails)));



// WEBPACK FOOTER //
// ./src/modules/orders/containers/OrderDetails.jsx